@if (shopHours.length === 1) {
  <div class="shop-type-distance-display long-hrs">
    {{ singleFormattedHours }}
  </div>
}
@if (shopHours.length > 1) {
  <div>
    @for (hour of formattedHours; track hour) {
      <div class="shop-type-distance-display long-hrs">
        <div>{{ hour.day }}</div>
        <div>{{ hour.hours }}</div>
      </div>
    }
  </div>
}
